import React from 'react';
import { useParent } from '../context/ParentContext';
import CourseHealthCard from '../components/cards/CourseHealthCard';
import ParentEmptyState from '../components/states/ParentEmptyState';
import '../components/cards/CourseHealthCard.css';
import './ParentCourses.css';

function ParentCourses() {
  const { currentCourses, selectedStudent, demoState } = useParent();

  if (demoState === 'empty' || currentCourses.length === 0) {
    return (
      <div className="parent-courses">
        <h1 className="parent-page-title">Courses</h1>
        <ParentEmptyState variant="no-data" />
      </div>
    );
  }

  return (
    <div className="parent-courses">
      <h1 className="parent-page-title">{selectedStudent?.firstName}'s Courses</h1>
      <p className="parent-courses__subtitle">{currentCourses.length} active courses</p>

      <div className="course-health-grid">
        {currentCourses.map(course => (
          <CourseHealthCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
}

export default ParentCourses;
